import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router";
import { AssetDropDown } from "../../UiComponents/AssetDropDown";
import { getAsset } from "../../actions/assetAction";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { AssetsList } from "../assetDetail/AssetsAUMList";
import { AssetReturnsList } from "../assetDetail/AssetReturnsList";
import { AssetPortfolioHoldings } from "../assetDetail/AssetPortfolio";
import { AssetTransactionsList } from "../assetDetail/AssetTransactions";
import { getAssetNotesTabDetails } from '../../actions/assetNotestabAction';
import { AssetTermsList } from "../assetDetail/Terms";
import { AssetExposureList } from "../assetDetail/Exposure";
import { getAssetReturns } from "../../actions/assetDetailsActions";
import { getAssetAUM } from "../../actions/assetDetailsActions";
import { getAssetSettings } from "../../actions/assetSettingsAction";
import { UrlPath } from "../../../config/routeConfig";
import { AssetDocumentsList } from "../assetDetail/Documents";
import "./Details.css";
import stared from "../returnsandstatistics/images/stared.svg";
import moment from "moment";
import { AssetShareClass } from "../assetDetail/Shareclass";
import { AssetServiceProvider } from "./serviceProvider";
import { AssetAttributes } from "../assetDetail/Attributes";
import { TopBar } from "../../shared/topBar/TopBar";
import close from "../../asset/Images/close_svg.svg";
import { TileLayout } from "@progress/kendo-react-layout";
import $ from "jquery";
import notificationSVG from '../../asset/Images/notification-text.svg';
import Settingicon from '../../asset/Images/settings.svg';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { getAssetDocuments } from "../../actions/assetDocumentsActions";
import { RecentNoteTab } from "./RecentNoteTab";
import { getShareClassbyAssetId } from "../../actions/assetShareClassAction";
import { getAssetShareclassTerms } from '../../actions/assetDetailsActions';
import { getAssetExposures } from "../../actions/assetDetailsActions";
import burgermenu from "../returnsandstatistics/images/burger-menu.svg";
import linechartup from "../returnsandstatistics/images/line-chart-up-01.svg";
import { getExposureAssetLevelChartAction } from "../../actions/privateExposureAction";
import { getMSDetailSection, getPrivateExposureCategoryTypeDates } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { Unauthorized } from "../../shared/ErrorPage/ErrorPage";
import {
    getAssetAttributes, getAssetRatingsAction, getAssetRatingsOddAction
} from "../../actions/assetAttributesActions";
import { ExposureCategory } from "../../../config/exposureConfig";
import { getCustomSettings, updateCustomSettings } from "../../../config/apiConfig";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { InvestmentAdd } from "../../library/EnhancedLibrary/InvestmentAdd";
import { SBNotify } from "../../utils/sbNotify";
import { Liquidity } from "./Liquidity";
import { getFrequencies1Action, getFrequencies2Action, getLiquidityLockTypeAction, getLiquidityLockupFrequencyAction, getLiquidityRequiredNoticeAction } from "../../actions/CommonAction";
import { ToastContainer } from "react-toastify";
import { Accordion, Modal } from "react-bootstrap";
import { AssetSetttingModal } from "../assetSettings/AssetSettings";
import { AgGridReact } from "ag-grid-react";


export const AssetDetails = () => {

  const removeDrawerTabIndex = () => {
    const drawers = document.getElementsByClassName('rs-drawer-wrapper');
    Array.from(drawers).forEach(drawer => {
      drawer.removeAttribute('tabIndex');
    });
};
removeDrawerTabIndex();

  const params = useParams();
  const history = useNavigate();
  let Level = ([{ BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` }]);
  const Gstate = useSelector(state => { return state; }) || {};
  const currentAsset = Gstate.asset.asset || {};
  const errorcode = Gstate.asset.errorcode || {};
  const [torender, SetToRender] = useState(false);
  const [Loading, setLoading] = useState(true);
  const [tiles, Settiles] = useState([]);
  const [TotalRemovedWidgetCount, SetTotalRemovedWidgetCount] = useState([]);
  const [TotalWidgetCount, SetTotalWidgetCount] = useState([]);
  const [ShowIcon, setShowIcon] = useState(false);
  const [cancelshow, setcancelshow] = useState(false);
  const [updateshow, setupdateshow] = useState(true);
  const [reorder, setReorder] = useState(false);
  const [shownotification, setShowNotification] = useState(false);
  const dispatch = useDispatch();
  const locationData = useLocation();
  const previouslyActiveTab = locationData.state === null ? "Details" : locationData.state.ActiveTab;
  const [activeTab, setActiveTab] = useState(previouslyActiveTab);
  const AuthorizationToken = sessionStorage.getItem('entryKey');
  const [gridbuttonActive, setGridbuttonActive] = useState(true);
  const [chartbuttonActive, setChartbuttonActive] = useState(false);
  const [gridView, setGridView] = useState(true);
  const [chartView, setChartView] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [WidgetCollections, setWidgetCollections] = useState([]);
  const [showNotes,setShowNotes]=useState(false);
  const [showDocuments,setShowDocuments]=useState(false);
  const [data, setData] = React.useState([{
    col: 1,
    colSpan: 1,
    rowSpan: 2
  },
  {
    col: 2,
    colSpan: 1,
    rowSpan: 2
  },
  {
    col: 3,
    colSpan: 1,
    rowSpan: 2
  },
  {
    col: 1,
    colSpan: 1,
    rowSpan: 2
  },
  {
    col: 2,
    colSpan: 1,
    rowSpan: 2
  },
  {
    col: 3,
    colSpan: 1,
    rowSpan: 2
  },
  {
    col: 1,
    colSpan: 1,
    rowSpan: 2
  },
  {
    col: 2,
    colSpan: 1,
    rowSpan: 2
  },
 
 


  ]);
  const [showAssetSetting,setShowAssetSetting]=useState(false);
  const [detailControl,setDetailControl]=useState({});
  const assetID = params.Asset;
  //const getassetDetails=assetDetailsUrl;
  const [unauthorised, setUnAuthorized] = useState(false); // Add state to track errors
  const [notesDrawer,setNotesDrawer]=useState(false);
  const isEditable = useSelector(state => state.authorizationData.isEditable);
const SelectedActivity=[{ActivityType:"Note",ActivityTypeId:"1"}];
const SelectedCategory=[{ActivitySubType:"Meeting Note",ActivitySubTypeId:"1",}]
const SelectedDocumentActivity=[{ActivityType:"Document",ActivityTypeId:"2"}];
const SelectedDocumentCategory=[{ActivitySubType:"General Document",ActivitySubTypeId:"20",}]
const Returns = useSelector(state => state.assetReturns.assetReturns[0]) || [];
const AssetAUM = useSelector((state) => state.assetAUM.assetAUM[0]);
const ExposureData=useSelector((state) =>state.assetPrivateExposureSummary.assetPrivateExposureSummary[0]);
const [ReturnDate, setReturnsAsofDate] = useState(Returns ? moment(Returns.AsofDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY'));
const [valuationDate,setValuationDate]= useState(AssetAUM?moment(AssetAUM.ValuationDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY'));
const [exposureDate,setExposureDate]= useState(ExposureData ? moment(ExposureData.ReportDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY'));
 // Previous Month End Date Start..
 const currentDate = new Date();
 const previousMonth = currentDate.getMonth() - 1;
 const previousMonthEndDate = new Date(currentDate.getFullYear(), previousMonth + 1, 0);
 const PDate = (moment(previousMonthEndDate).format('MM-DD-YYYY'));
 //Previous Month End Date..
  useEffect(()=>{
    document.title = "Asset Details";
    dispatch(getLiquidityLockupFrequencyAction());
    dispatch(getLiquidityLockTypeAction());
    dispatch(getLiquidityRequiredNoticeAction());
    dispatch(getAssestListddlAction());
    dispatch(getFrequencies2Action());
    dispatch(getFrequencies1Action());
  },[])
  useEffect(() => { 
    dispatch(getAsset(params.Asset));
    dispatch(getAssetReturns(params.Asset, '1'));
    dispatch(getAssetSettings(params.Asset, 1));
    dispatch(getAssetDocuments(params.Asset));
    dispatch(getAssetNotesTabDetails(params.Asset));
    dispatch(getShareClassbyAssetId(params.Asset, true));
     dispatch(getAssetAUM(params.Asset, PDate));
    dispatch(getAssetExposures(params.Asset));
    //dispatch(getPrivateExposureCategoryTypeDates(params.Asset));
    getMinMaxValues();
    getCustomSetting();
    //loadWidget(); 


  }, [torender, assetID, activeTab]);

  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const Docs = Gstate.Documents.Documents || [];
  const NotesTabDetails = useSelector(state => state.notesTabDetails?.notesTab) || [];
 
  useEffect(() => {
    setReturnsAsofDate(Returns ? moment(Returns.AsofDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY'));
  setValuationDate(AssetAUM?moment(AssetAUM.ValuationDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY'));
  setExposureDate(ExposureData ? moment(ExposureData.ReportDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY'));
  loadWidget();
    (currentAsset && AssetListDDL) && setLoading(false);
    if (errorcode == 401 || errorcode == 403) {
      setUnAuthorized(true);
    }
  }, [Gstate]);
    const AssetDDChanged = (e) => {
    if (e.value) {
      history(`${UrlPath.AssetDetails}${e.value.AssetId}`);
      dispatch(getAsset(e.value.AssetId));
      SetToRender(!torender);
      dispatch(getAssetReturns(e.value.AssetId, '1'));
      dispatch(getAssetAUM(e.value.AssetId, PDate));
      dispatch(getShareClassbyAssetId(e.value.AssetId, true));
      dispatch(getAssetShareclassTerms(e.value.AssetId));
      dispatch(getAssetExposures(e.value.AssetId));
      dispatch(getAssetAttributes());
      dispatch(getAssetNotesTabDetails(params.Asset));
      dispatch(getAssetRatingsAction(e.value.AssetId));
      dispatch(getAssetRatingsOddAction(e.value.AssetId));
    }

  }
  const AddButtonClick = () => {
    history(`${UrlPath.AssetAdd}`, { state: { ActiveTab: "AssetDetails", currentAssetId: params.Asset } });
  };
  const data1 = localStorage.getItem("userData");

  const ViewClick = (type) => {
    if (type == "Returns") {
      history(`/${UrlPath.AssetReturnStatics}${params.Asset}`);
    }
    else if (type == "Exposures") {
      history(`${UrlPath.PrivateExposure}${params.Asset}`);
    }
    else if (type == "Share Class Terms") {
      setActiveTab('shareClass');
    }
    else if (type == "Assets") {
      history(`${UrlPath.AUMList}${params.Asset}`);
    }
    
    else if(type=="Recent Notes")
    {
      const NoteActivity=[{ ActivityType :  "Note", ActivityTypeId : 1 }]
      history(`${UrlPath.Documents}`, { state:{Activity: NoteActivity } });
    }
    else if(type=="Recent Documents")
    {
      const documentActivity=[{ ActivityType :  "Document", ActivityTypeId : 2 }]
      history(`${UrlPath.Documents}`, { state:{Activity: documentActivity }});
    }
    else {
      history(`${UrlPath.AssetDetails}${params.Asset}`, { state:  { ActiveTab: "Details", ActiveTabID: 1 } });
    }
  };
  const [ComponentNames, setComponentNames] = useState([
    { "componentId": 'C1', "Component": AssetsList },
    { "componentId": 'C2', "Component": AssetReturnsList },
    { "componentId": 'C3', "Component": AssetTermsList },
    { "componentId": 'C4', "Component": AssetExposureList },
    { "componentId": 'C5', "Component": AssetPortfolioHoldings },
    { "componentId": 'C6', "Component": AssetTransactionsList },
    { "componentId": 'C7', "Component": RecentNoteTab },
    { "componentId": 'C8', "Component": AssetDocumentsList }
    

  ]);

  // Widgets added in collections ..
  //   const [WidgetCollections, setWidgetCollections] = useState(data1 != "null" ? JSON.parse(data1) : [
  //   { "WidgetName": 'Assets widget', "SortOrder": 1, 'componentId': 'C1', "IsRemoved": false, "TitleName": "Assets", "WidgetId": "Assets" },
  //     { "WidgetName": 'Returns widget', "SortOrder": 2, 'componentId': 'C2', "IsRemoved": false, "TitleName": "Returns"   , "WidgetId": "Returns" },
  //   { "WidgetName": 'Terms  widget', "SortOrder": 3, 'componentId': 'C3', "IsRemoved": false, "TitleName": "Share Class Terms", "WidgetId": "ShareClass" },
  //   { "WidgetName": 'Exposure widget', "SortOrder": 4, 'componentId': 'C4', "IsRemoved": false, "TitleName": "Exposures", "WidgetId": "Exposures" },
  //   { "WidgetName": 'Portfolio widget', "SortOrder": 5, 'componentId': 'C5', "IsRemoved": false, "TitleName": "Portfolio", "WidgetId": "Portfolio" },
  //   { "WidgetName": 'Transactions widget', "SortOrder": 6, 'componentId': 'C6', "IsRemoved": false, "TitleName": "Transactions", "WidgetId": "Transactions" }

  // ]);

  const getCustomSetting = async () => {
    try {
      const response = await sbaAxios({ url: `${getCustomSettings}2` });
      const assetDetail = await sbaAxios({ url: `${getCustomSettings}1` });
      if (response) {
        const widgetSettings = JSON.parse(response.CustomSettingsValue);
        setWidgetCollections(widgetSettings);
       const data = widgetSettings.map((item) => item.dataPosition);
       setData(data);
        await loadWidget();
      }
      if(assetDetail)
      {
        const options = JSON.parse(assetDetail.CustomSettingsValue);
        setDetailControl({CustomSettingsValue:options,CustomFilterValue:assetDetail.CustomFilterValue});
      }
    } catch (error) {
      console.log(error);
    }
  };
  localStorage.setItem("userData", data1 || WidgetCollections);
 const OpenNotesDrawer=()=>setNotesDrawer(true);
  // Exposure Component event Start....
  const ReturnGridValue = () => {
    setGridView(true);
    setChartView(false);
    setGridbuttonActive(true);
    setChartbuttonActive(false);
    loadWidget();
  }

  const ReturnChartValue = () => {
    setGridView(false);
    setChartView(true);
    setGridbuttonActive(false);
    setChartbuttonActive(true);
    getMinMaxValues();
  }
  const getMinMaxValues = async () => {
    if (params.Asset) {
      try {
        const response = await sbaAxios({
          url: `${getPrivateExposureCategoryTypeDates}${params.Asset}`,
          method: 'get',
        })
        const MinMaxDateValue = {
          MinDate: (response && response.length > 0 && response[0].MinDateFormatted !== null && response[0].MinDateFormatted !== undefined) ? response[0].MinDateFormatted : "",
          MaxDate: (response && response.length > 0 && response[0].MaxDateFormatted !== null && response[0].MaxDateFormatted !== undefined) ? response[0].MaxDateFormatted : "",
        };
        if (
          MinMaxDateValue.MinDate !== null &&
          MinMaxDateValue.MaxDate !== null
        ) {
          const formattedStartDate = moment(MinMaxDateValue.MinDate).format("MM-DD-YYYY");
          const formattedEndDate = moment(MinMaxDateValue.MaxDate).format("MM-DD-YYYY");
          dispatch(
            getExposureAssetLevelChartAction(
              formattedStartDate,
              formattedEndDate,
              params.Asset,
              ExposureCategory.AssetLevel,
              true
            ));
        }
      } catch (error) {
        console.error("Error fetching MinMaxValues from API:", error);
      }
    }
  };
  // Exposure Component event end....
  //Widget load...
  const loadWidget = () => {
    localStorage.setItem("userData", JSON.stringify(WidgetCollections));
    const TotalRemovedCount = $.grep(WidgetCollections, function (item) {
      return item.IsRemoved === true;
    });
    const TotalCount = $.grep(WidgetCollections, function (item) {
      return item.IsRemoved === false;
    });
    const tiles1 = [];
    if (cancelshow == true) {
      setReorder(true);
    }
    WidgetCollections.map(function (item) {
      if (item.IsRemoved == false) {
        const tile =
        {
          header:
            <div class="card-header d-flex justify-content-between align-items-center">
              <ul class="list-unstyled d-flex align-items-center gap-2 m-0">
                <li style={{ fontWeight: "bold" }}>
                {
  item.TitleName === "Returns" ? `${item.TitleName} - As Of ${ReturnDate}` :
  item.TitleName === "Assets" ? `${item.TitleName} - As Of ${valuationDate}` :
  item.TitleName === "Exposures" ? `${item.TitleName} - As Of ${exposureDate}` :
  item.TitleName
}
                </li>
                {shownotification && (
                  <li class="notification-text"><img src={notificationSVG} alt="Notification" />
                    <div class="card-hover" >
                      <div class="card p-3">
                        <div class="card-header d-flex justify-content-between align-items-center px-0">
                          <p class="m-0 fw-semibold">{item.TitleName}</p>
                        </div>
                        Not Available
                      </div>
                    </div>
                  </li>
                )}
              </ul>
              {/* <ul class="list-unstyled d-flex align-items-center gap-2 m-0">
              {item.TitleName === "Recent Notes" && <RecentNoteTab />}
              </ul> */}
              <ul class="list-unstyled d-flex align-items-center gap-2 m-0">
                {item.TitleName === "Exposures"  && (
                  <li>
                    <div className="col-lg-12 d-flex  justify-content-lg-end p-0 align-items-center">
                      <button
                        className={`toggle-btn rounded-start ${gridbuttonActive && "active"
                          }`}
                        onClick={() => ReturnGridValue()}
                      >
                        <span>
                          <img
                            src={burgermenu}
                            alt=""
                            style={{
                              filter: gridbuttonActive
                                ? "brightness(100%)"
                                : "brightness(50%)",
                            }}
                          />
                        </span>{" "}

                      </button>
                      <button
                        className={`toggle-btn rounded-end ${chartbuttonActive && "active"
                          }`}
                        onClick={() => ReturnChartValue()}
                      >
                        <span>
                          <img
                            src={linechartup}
                            alt=""
                            style={{
                              filter: chartbuttonActive
                                ? "brightness(100%)"
                                : "brightness(50%)",
                            }}
                          />
                        </span>{" "}

                      </button>

                    </div>

                  </li>
                )}
                 {item.TitleName === "Recent Notes"  && (
                  <li>
                    <div className="col-lg-12 d-flex  justify-content-lg-end p-0 align-items-center">
                      <button
                        className={`toggle-btn rounded active`}
                        onClick={() => {
                          OpenNotesDrawer();
                          setShowDocuments(false);
                          setShowNotes(true);
                        }}
                      >
                         <i className="fa-solid fa-plus"></i>
                      </button>

                    </div>

                  </li>
                )}
                     {item.TitleName === "Recent Documents"  && (
                  <li>
                    <div className="col-lg-12 d-flex  justify-content-lg-end p-0 align-items-center">
                      <button
                        className={`toggle-btn rounded active`}
                        onClick={() => {
                          OpenNotesDrawer();
                          setShowNotes(false);
                          setShowDocuments(true);
                        }}
                      >
                         <i className="fa-solid fa-plus"></i>
                      </button>

                    </div>

                  </li>
                )}
                <li><span class="text-decoration-none SBA_hand text-primary" onClick={() => ViewClick(item.TitleName)}>View</span>
                </li>

                <li>
                  <div class="dropstart dropdown-card">
                    {ShowIcon && (
                      <a className="ms-auto" href="#" onClick={() => RemoveWidget(item.TitleName)}><img src={close}
                        alt="close" /></a>)}
                  </div>
                </li></ul>
                
            </div>,
          body: (
            <>

              {

                ComponentNames.map(function (Citem) {
                  if (item.componentId == Citem.componentId && item.TitleName !== "Exposures") {
                    return <Citem.Component />
                  }
                
                  else if (item.componentId == Citem.componentId && item.TitleName === "Exposures") {
                    if (gridbuttonActive) {
                      return <Citem.Component view={"grid"} />
                    }
                    else {
                      return <Citem.Component view={"chart"} />
                    }
                  }
                  else {
                    return
                  }
                })
              }


            </>
          ),
          reorderable: cancelshow,
        }

        tiles1.push(tile);
      }
    })
    if (ShowIcon == true) {
      if (TotalRemovedCount.length > 0) {
        // TotalRemovedCount.map(function (item) { 
        const tile =
        {
          body: (

            <div class="col-md-6 col-lg-4">
              <div class="card" style={{ width: "300%" }}>
                <div class="add-widget h-300">
                  <button class="d-inline-block w-100 h-100 fs-5"
                    data-bs-toggle="modal" data-bs-target="#exampleModal">
                    + Add a Widget
                  </button>
                </div>
              </div>
            </div>

          ),
 reorderable: false,
        }
        tiles1.push(tile);
        // })
      }
    }
    Settiles(tiles1);

  }

  const handleReposition = (e) => {
   setData(e.value);
    WidgetCollections.forEach((widget, index) => {
      if (e.value[index]) {
        widget.SortOrder = e.value[index].order;
      }
    });
    const updatedWidgetCollections = WidgetCollections.map((widget, index) => ({
      ...widget,
      dataPosition:e.value[index]
    }));
    setWidgetCollections(updatedWidgetCollections);
  };
  const EditButtonClick = () => {
    history(`${UrlPath.AssetEdit}${params.Asset}`);
  };
  //Level = !(currentAsset == {}) ? ([...Level, { BreadCrumb: `${currentAsset?.AssetName}`, Routes: `${UrlPath.AssetDetails}${params.Asset}` }]) : Level;

  Level = Loading
    ? Level : ([...Level, { BreadCrumb: `${currentAsset?.AssetName}`, Routes: `${UrlPath.AssetDetails}${params.Asset}` }])

  const RemoveWidget = (name) => {

    $.grep(WidgetCollections, function (item) {
      if (item.TitleName == name) {
        item.IsRemoved = true;
      }
    });
    setWidgetCollections(WidgetCollections);
    loadWidget();
    localStorage.setItem("userData", JSON.stringify(WidgetCollections));
  };

  const Widgets = () => {
    return (
      <div class="row">
        {WidgetCollections.map(function (item) {
          if (item.IsRemoved === true) {
            return (
              <div className="col-sm-4 col-md-4">
                <div className="widget-checkbox rounded">
                  <div className="form-check float-end">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id={"AssetCheck_" + item.componentId}
                      onChange={(e) => setwidgets(e, item.componentId)} />
                  </div>
                </div>
                <span className="mt-2 d-inline-block">{item.TitleName}</span>
              </div>

            );
          }
          return null;
        })}
      </div>
    );
  };
  const setwidgets = (e, name) => {
    $.grep(WidgetCollections, function (item) {
      if (item.componentId == name) {
        if ($('#AssetCheck_' + item.componentId + '').prop("checked") == true) { item.IsRemoved = false; }
        else {
          item.IsRemoved = true;
        }
      }

    });
    setWidgetCollections(WidgetCollections);
  };
  function handleButtonClick() {
      setShowIcon((prevShowIcon) => !prevShowIcon);  
          setcancelshow(true);
          setupdateshow(false);   
  };
  const handleAttributeCustomize=()=>{

  }
  function cancelsettingsClick() {
    setupdateshow(true);
    setcancelshow(false);
    setShowIcon(false);
  };
  useEffect(() => {
    loadWidget();
  }, [ShowIcon, gridbuttonActive, chartbuttonActive, WidgetCollections, data]);

  const SaveWidgetSettings = () => {
    const saveData = {
      "componentId": 2,
      "componentUserSettingId": 0,
      "userId": 0,
      "customSettingsValue": JSON.stringify(WidgetCollections),
      "isGrid": true
    };
    sbaAxios({ url: updateCustomSettings, method: 'post', data: saveData }).then(response => {
      setcancelshow(false);
      setupdateshow(true);
      setShowIcon(false);
    }).catch(error => { console.log(error) });
  };
  const showNotesSave=(type)=>{
    SBNotify({ Msg: `${type} Saved Successfully` });    
    SetToRender(!torender);
  };
  const DataSourceId=currentAsset?.DataSourceId || 0;
  return ( <>
    <div>
      <TopBar label={"Asset Details"} />
      {!unauthorised ?
        <>
          <BreadCrumbs Levels={Level} />
          <div id="content" class="asset-detail-screen mainContentData assetDetail">
            <div class="p-4">
              <div class="d-flex align-items-center justify-content-between my-2 flex-wrap flex-lg-nowrap">
                <div class="d-flex gap-2 align-items-center">
                  <h2 class="fw-medium fs-6 m-0">{currentAsset?.AssetName}</h2>
                  {/* <Link title="Asset Settings" to={{ pathname: `${UrlPath.AssetSetting}${currentAsset?.AssetId}` }}><i className="fa-solid fa-gear SBA_hand"></i></Link> */}
                </div>
                <div>
                  {/* <form> */}
                  <div className="row">
                    <div className="col-lg-12 d-flex gap-3 justify-content-lg-end p-0 align-items-center">
                      <div style={{ width: "500px", marginLeft: "auto" }}>
                        <AssetDropDown
                          value={currentAsset}
                          // onChange={AssetDDChanged}
                          data={AssetListDDL}
                          onClose={AssetDDChanged}
                        />                    </div>
                      {/* <a href="#"><img src={stared} alt="" /></a> */}
                                          <div className="d-flex gap-2">
                                              <button className='p-sm-btn mx-1' onClick={AddButtonClick} disabled={!isEditable}>
                                                  <i className="fa-solid fa-plus" /> Add
                                                </button>
                                              {updateshow && (
                                                <> 
                            {activeTab == "Details" && <>
                              <button className='p-sm-btn mx-1' onClick={handleButtonClick} >
                                <img src={Settingicon} alt="" className="WhiteImage" /> Modify View
                              </button>
                            </>}
                            {activeTab == "Attributes" && <>
                              <button className='p-sm-btn mx-1' onClick={()=>{handleAttributeCustomize()}} >
                                <img src={Settingicon} alt="" className="WhiteImage" /> Modify View
                              </button>
                            </>}
                            {activeTab !== "Details" && activeTab !== "Attributes"  && <>
                              <button className='p-sm-btn mx-1'  disabled>
                                <img src={Settingicon} alt="" className="WhiteImage" /> Modify View
                              </button>
                            </>}
                          </>
                                              )}
                                              
                                              {cancelshow && (
                                                  <div className="d-flex gap-2">
                                                      <button
                                                          className="s-sm-btn mx-1"
                                                          onClick={cancelsettingsClick}
                                                          style={{
                                                              display: activeTab !== 'Details' ? 'none' : 'inline-block'
                                                          }}
                                                      >
                                                          <img src={Settingicon} alt="" /> Cancel Settings
                                                      </button>
                                                      <button
                                                          className="p-sm-btn mx-1"
                                                          onClick={SaveWidgetSettings}
                                                          style={{
                                                              display: activeTab !== 'Details' ? 'none' : 'inline-block'
                                                          }}
                                                      >
                                                          Save
                                                      </button>
                                                  </div>
                                              )}

                                          
                                          </div>

                    </div>
                  </div>
                  {/* </form> */}
                </div>
              </div>
              <Tabs
                defaultActiveKey={'Details'}
                activeKey={activeTab}
                onSelect={(key) => setActiveTab(key)}
                id="uncontrolled-tab-example"
                className="ms-3"
              >
                <Tab eventKey="Details" title="Details">
                  <div class="p-3 bg-white life-science rounded">
                    <div className="row m-0" style={{ margintop: "-5px" }}>
                      <div class="col-8 px-0" id="detailsValue">
                        <div class="row detail m-0 p-3 pe-0">
                          <div class="col-md-3">
                            <div class="mb-4">
                              <span class="fw-medium">Asset Name</span>
                              <p class="fw-medium mb-0">{currentAsset.AssetName}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Abbreviation Name</span>
                              <p class="fw-medium mb-0">{currentAsset.AbbrName}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Asset Manager</span>
                              <p class="fw-medium mb-0">{currentAsset.ManagerContact ? currentAsset.ManagerContact : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Security Type</span>
                              <p class="fw-medium mb-0">{currentAsset.SecurityType ? currentAsset.SecurityType : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Inception Date</span>
                              <p class="fw-medium mb-0">{currentAsset.EffectiveDate && (moment(currentAsset.EffectiveDate).format('MM/DD/YYYY'))}</p>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="mb-4">
                              <span class="fw-medium">Investment Status</span>
                              <p class="fw-medium mb-0">{currentAsset.InvestmentStatus ? currentAsset.InvestmentStatus : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Asset Status</span>
                              <p class="fw-medium mb-0">{currentAsset.AssetStatus ? currentAsset.AssetStatus : "None"}</p>
                            </div>


                            <div class="mb-4">
                              <span class="fw-medium">Primary Analyst</span>
                              <p class="fw-medium mb-0">{currentAsset.PrimaryAnalyst ? currentAsset.PrimaryAnalyst : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Secondary Analyst</span>
                              <p class="fw-medium mb-0">{currentAsset.SecondaryAnalyst ? currentAsset.SecondaryAnalyst : "None"}</p>
                            </div>

                            <div class="mb-4">
                              <span class="fw-medium">Asset Class</span>
                              <p class="fw-medium mb-0">{currentAsset.AssetClass ? currentAsset.AssetClass : "None"}</p>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="mb-4">
                              <span class="fw-medium">Strategy</span>
                              <p class="fw-medium mb-0">{currentAsset.Strategy ? currentAsset.Strategy : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Substrategy</span>
                              <p class="fw-medium mb-0">{currentAsset.Substrategy ? currentAsset.Substrategy : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Sector</span>
                              <p class="fw-medium mb-0">{currentAsset.Sector ? currentAsset.Sector : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Subsector</span>
                              <p class="fw-medium mb-0">{currentAsset.SubSector ? currentAsset.SubSector : "None"}</p>
                            </div>
                            <div class="mb-4">
                              <span class="fw-medium">Region</span>
                              <p class="fw-medium mb-0">{currentAsset.Region ? currentAsset.Region : "None"}</p>
                            </div>


                          </div>
                          <div class="col-md-2">
                            <div class="mb-4">
                              <span class="fw-medium">Classification</span>
                              <p class="fw-medium mb-0">{currentAsset.Subregion ? currentAsset.Subregion : "None"}</p>
                            </div>
                            <div class="mb-4 SBA_hand" onClick={()=>{setShowAssetSetting(true)}} >
                              <span class="fw-medium">Benchmark 1</span>
                              <p class="fw-medium mb-0">{currentAsset.PrimaryBM}</p>

                            </div>
                            <div class="mb-4 SBA_hand" onClick={()=>{setShowAssetSetting(true)}}>
                              <span class="fw-medium">Benchmark 2</span>
                              <p class="fw-medium mb-0">{currentAsset.SecondaryBM}</p>
                            </div>
                            <div class="mb-4">
                            <span className="d-flex">
                              <span class="fw-medium"  >IDD Rating</span><span className="ms-2 roundedIcon" title={(currentAsset?.IddRating!=='N/A')  && moment(currentAsset?.IddDate).format("MM-DD-YYYY")}>i</span>
                            </span>  
                            <p class="fw-medium mb-0 ">{currentAsset?.IddRating}</p>
                            </div>
                            <div class="mb-4">
                              <span className="d-flex">
                              <span class="fw-medium"  >ODD Rating </span><span className="ms-2 roundedIcon" title={(currentAsset?.OddRating!=='N/A')  && moment(currentAsset?.OddDate).format("MM-DD-YYYY")}>i</span>
                              </span>
                              <p class="fw-medium mb-0">{currentAsset?.OddRating}</p>
                            </div>
                          </div>
                          <div class="col-md-1 d-flex justify-content-end">
                            <Link title="Click to edit Details" to={isEditable && `${UrlPath.AssetEdit}${params.Asset}`}
                              state={{ ActiveTab: 'Details', ActiveTabID: 1, CurrentPage: "AssetDetails" }}
                              className={isEditable ? "" : "disabledControl"}
                            >
                              <i className="fa-solid fa-pencil edit_icon"></i>
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div class="col-4 py-md-2 py-lg-0 p-3 bg-white life-science rounded" id="strategyDescription" style={{ backgroundColor: '#cfe2ff !important' }}>
                        <div >
                          <div
                            class="accordion accordion-flush"
                            id="accordionFlushExample"
                          >
                            <div style={{ marginTop: '13px' }}>
                            <p class="fw-medium" id="TextStrategy">Strategy Description</p>
                              <div
                                class="accordion-collapse collapse show"
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div class="accordion-body" >
                                  <span className="fw-medium">
                                    {currentAsset.StrategyDescription ? currentAsset.StrategyDescription : ""}
                                  </span>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      </div>
                      {DataSourceId == 11 &&
                        <>
                                <MarketableSecurityScreen bloombergId={currentAsset?.BloombergId} />

                          {/* <Accordion defaultActiveKey="0" className="p-0 my-2 accordionFullHeight" >
                            <Accordion.Item eventKey="0" >
                              <Accordion.Header  style={{ '--bs-accordion-active-bg': '#F0F6FD' }}>Key Statistics</Accordion.Header>
                              <Accordion.Body className="bg-white">
                              </Accordion.Body></Accordion.Item></Accordion> */}
                        </>}
                      <div class="widgets py-3">
                        <div class="row" id="assettile" >
                          <TileLayout className="bg-white"  positions={data} items={tiles} onReposition={handleReposition} />
                        </div>
                      </div>
                    </div>

                  </div>
                </Tab>
                <Tab eventKey="Attributes" title="Attributes">
                  <div className=" bg-white life-science rounded">
                    {activeTab==="Attributes" && <>
                    <AssetAttributes options={detailControl}/>
                    </> }
                  </div>
                </Tab>
                <Tab eventKey="shareClass" title="Share Class">
                  <div class="p-3 bg-white life-science rounded">
                  {activeTab==="shareClass" && <>
                    <AssetShareClass />
                    </> }
                  </div>
                </Tab>
                <Tab eventKey="liquidity" title="Liquidity">
                  <div class="p-3 bg-white life-science rounded">
                  {activeTab==="liquidity" && <>
                    <Liquidity />
                    </> }
                  </div>
                </Tab>
                <Tab eventKey="serviceProvider" title="Service Provider">
                  <div class="p-3 bg-white life-science rounded">
                  {activeTab==="serviceProvider" && <>
                    <AssetServiceProvider />
                    </> }
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
          <div class="modal fade" id="exampleModal" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div
              class="modal-dialog modal-dialog-centered modal-dialog-scrollable widget-add-modal">
              <div class="modal-content p-2 overflow-auto">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="exampleModalLabel">Add Widgets
                  </h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
                </div>
                <form>
                  <div class="modal-body ">
                    <h6 class="fw-medium fs-6 mt-3">Click on the widget checkbox
                      to
                      add
                    </h6>
                    <Widgets />
                  </div>
                  <div class="modal-footer border-0">
                    <button type="button" class="cancel-btn"
                      data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="apply-btn" onClick={() => loadWidget()} data-bs-dismiss="modal">Apply</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <SBADrawer 
          open={notesDrawer} 
          setOpen={setNotesDrawer} 
          size='lg' 
          title={showNotes?"Add New Note":"Add New Documents"}
          >
            <InvestmentAdd
             Modal={true}  
             selectedAsset={currentAsset} 
             SelectedActivity={showNotes?SelectedActivity:SelectedDocumentActivity} 
             SelectedCategory={showNotes?SelectedCategory:SelectedDocumentCategory} 
             setDrawerSet={setNotesDrawer} 
             ActivityDisable={true} 
             afterSave={showNotesSave} 
             ShowDocuments={showDocuments} 
             /></SBADrawer>
         {showAssetSetting} <Modal 
             show={showAssetSetting}
             dialogClassName="modal-75w"

             >
            <Modal.Header
              closeButton
            onClick={() => {
              setShowAssetSetting(false);
            }}
            >
              <Modal.Title>
                BM Settings
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <AssetSetttingModal setShowModal={setShowAssetSetting} onSave={()=>{SetToRender(val=>!val)}} />
            </Modal.Body>
          </Modal>
          </> : <><Unauthorized /></>}
    </div>
  <ToastContainer/>  
  </>
  )
}


const MarketableSecurityScreen = ({ bloombergId }) => {
  const [tiles,setTiles]=useState([]);

  useEffect(() => {
    if (bloombergId) {
      FetchData(bloombergId);
    } else {

    }
  }, [bloombergId]);

  const FetchData = async (bloombergId) => {
    try {
      const res = await sbaAxios({ url: `${getMSDetailSection}${bloombergId}`, method: 'post' });
      res.Samplekey=[];
      const tile = [];
      Object.entries(res).map(([key, value]) => {
        value.length>0 &&
        tile.push({
          header: <div className="header-container ">
            <b className="text-nowrap">{formatTitle(key)}</b>
          </div>,
          body: <>  <div  className="d-flex flex-column column-gap-1" >
          {Array.isArray(value) && (
            value.map((item, index) => (
                <div  key={index} className="row m-1 p-1
                border-bottom
                " style={{background:index%2==0?  '' :'' }}>
                  <span className="fw-medium col text-nowrap">{item.ItemDescription}</span>
                  <p className="fw-medium col text-nowrap text-end d-inline me-3">{item.ItemValue}</p>
                </div>
            ))
          )}
              </div></>,
          resizable: false,
          componentID: 'C1',
          keyName:key
        })
      });
      const orderedKeyname = [
        "Overview", 
        "Valuation",
        "Profitability",
        "IncomeStatement",
        "Dividends",
        "ManagementEffectiveness",
        "StockPriceHistory",
        "AnalystConsensus"
    ];
    tile.sort((a, b) => {
      const indexA = orderedKeyname.indexOf(a.keyName);
      const indexB = orderedKeyname.indexOf(b.keyName);
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  });
      setTiles(val=>tile);
    } catch (error) {
    }
  };
  const colDef = [
    { headerName: "Description", field: "ItemDescription" },
    {headerName: "Value", field: "ItemValue"}
];

  return (<>
  
  {tiles.length > 0 ? <> <Accordion defaultActiveKey="0" className="p-0 my-2 accordionFullHeight" >
    <Accordion.Item eventKey="0" >
      <Accordion.Header  style={{ '--bs-accordion-active-bg': '#F0F6FD' }}>Key Statistics</Accordion.Header>
      <Accordion.Body className="bg-white">
      <div id="assettile"> </div><TileLayout
      className="bg-white"
      items={tiles}
      columns={3}
      positions={dataModel}
    /> </Accordion.Body></Accordion.Item></Accordion></> : <div className="text-center">
      {/* No Data Available */}
    </div>}
  
  </>
    

     
  
 
  );
};
const formatTitle = (str) => {
  return str.replace(/([A-Z])/g, ' $1').trim();
};


const dataModel=[
  { col: 1, colSpan: 1, rowSpan: 2 },
  { col: 2, colSpan: 1, rowSpan: 2 },
  { col: 3, colSpan: 1, rowSpan: 2 },
  { col: 1, colSpan: 1, rowSpan: 2 },
  { col: 2, colSpan: 1, rowSpan: 2 },
  { col: 3, colSpan: 1, rowSpan: 2 },
  { col: 1, colSpan: 1, rowSpan: 2 },
  { col: 2, colSpan: 1, rowSpan: 2 },
  { col: 3, colSpan: 1, rowSpan: 2 },
  { col: 1, colSpan: 1, rowSpan: 2 },
  { col: 2, colSpan: 1, rowSpan: 2 },
  { col: 3, colSpan: 1, rowSpan: 2 },
  { col: 1, colSpan: 1, rowSpan: 2 }
];